import { IconType } from 'react-icons'
import { Link } from 'react-router-dom'

interface DropdownMenuItemProps {
  to: string
  title: string
  icon?: IconType
  iconSide?: 'left' | 'right'
  hasPermission?: boolean
}

export function DropdownMenuItem({ to, title, icon: Icon, iconSide = 'left', hasPermission = false }: DropdownMenuItemProps) {
  if (!hasPermission) return <></>

  return (
    <Link to={to}>
      <div className="flex items-center justify-between p-3 gap-8 hover:bg-slate-200 transition-all">
        {Icon && iconSide === 'left' && <Icon />}
        <span className="whitespace-nowrap">
          {title}
        </span>
        {Icon && iconSide === 'right' && <Icon />}
      </div>
    </Link>
  )
}
